module.exports = __webpack_public_path__ + "static/water7-ece3f649f096acc9dd98c6f8186b5b05.jpg";